export default ({ query, store, isDev }) => {
  if (!store.state.version) {
    const version = process.env.STORYBLOK_VERSION || (query._storyblok || isDev ? 'draft' : 'published');
    
    store.commit('setVersion', version);
  }
}